/**
 * Ephemeral tree UI context: search, expand/collapse, multi-toolbar selection state.
 */ import { useRef } from "react";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const TREE_INTERACTION_INHERIT_KEYS = [
    "collapsed",
    "stickyTreeCalculatedTop",
    "searchTerm",
    "resultSelectedNodeIdx",
    "resultTreeBusy",
    "resultTree",
    "renamingNodeId"
];
const TREE_INTERACTION_SYMBOL = Symbol();
const useTreeInteraction = ()=>useImmutableContext(TREE_INTERACTION_SYMBOL);
function useTreeInteractionProvider(state, handlers) {
    const handlersRef = useRef(handlers);
    handlersRef.current = handlers;
    return useImmutableContextProvider(TREE_INTERACTION_SYMBOL, state, {}, {
        inherit: [
            ...TREE_INTERACTION_INHERIT_KEYS
        ],
        refActions: {
            handleSearchChange: (_ctx, value)=>handlersRef.current.handleSearchChange(value),
            handleSearchClose: ()=>handlersRef.current.handleSearchClose(),
            handleSearchBlur: ()=>handlersRef.current.handleSearchBlur(),
            handleSearchKeyDown: (_ctx, event)=>handlersRef.current.handleSearchKeyDown(event),
            getExpandedState: ()=>handlersRef.current.getExpandedState(),
            getExpandedNodes: (_ctx, expandedState)=>handlersRef.current.getExpandedNodes(expandedState),
            handleNodeExpand: (_ctx, expanded, node)=>handlersRef.current.handleNodeExpand(expanded, node),
            handleCheck: (_ctx, id)=>handlersRef.current.handleCheck(id),
            handleToggleAll: ()=>handlersRef.current.handleToggleAll(),
            handleCloseMultiToolbar: ()=>handlersRef.current.handleCloseMultiToolbar(),
            registerSortableUl: (_ctx, ul, id)=>handlersRef.current.registerSortableUl(ul, id),
            setRenamingNodeId: (_ctx, id)=>handlersRef.current.setRenamingNodeId(id)
        }
    });
}
export { useTreeInteraction, useTreeInteractionProvider };
